import { MutationTree } from 'vuex';
import { cartInterFace, dailyLottoState, itemDailyLotto } from '@/types/store';
import { Market } from '@/types/daily-lotto';

interface actionRemoveCart {
    cart: cartInterFace[];
    total: number;
}

export const mutations: MutationTree<dailyLottoState> = {
    SET_DRAWS(state, draws: itemDailyLotto[]) {
        state.draws = draws;
    },
    SET_MARKETS(state, markets: Market[]) {
        state.markets = markets;
    },
    ADD_TO_CART(state, cart: cartInterFace[]) {
        state.totalDaily = cart?.length || 0;
        state.cartDaily = cart;
    },
    REMOVE_TO_CART(state, payload: actionRemoveCart) {
        state.totalDaily = payload.total;
        state.cartDaily = payload.cart;
    },
};

export default mutations;
